import { Modal } from "antd";
import { FC } from "react";
import FeedbackGuideForSpeaking from "./FeedbackGuideForSpeaking";
import FeedbackGuideForWriting from "./FeedbackGuideForWriting";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  feedbackTypeCode: string;
  isRewrite?: boolean;
}

const FeedbackGuideModal: FC<IProps> = ({
  visible,
  setVisible,
  feedbackTypeCode,
  isRewrite= false
}) => {
  return (
    <Modal
      title="Teacher's Feedback Guide"
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[]}
    >
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {
          feedbackTypeCode === 'SP'
            ? <FeedbackGuideForSpeaking />
            : <FeedbackGuideForWriting isRewrite={isRewrite} />
        }
      </div>
    </Modal>
  );
}

export default FeedbackGuideModal;
